import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import {
  ExpandInfoDrawerAction,
  ManageAspectsAction,
  NodeActionTypes,
} from '@alfresco/aca-shared/store';
import { ContentManagementService } from '@adw/projects/aca-content/src/lib/services/content-management.service';

import { AppStore } from '../states/app.state';
import { getAppSelection } from '../selectors/app.custom-selectors';

@Injectable({
  providedIn: 'root',
})
export class NodeEffects {
  private readonly router: Router;
  private readonly contentService: ContentManagementService;

  constructor(
    injector: Injector,
    private readonly store: Store<AppStore>,
    private readonly actions$: Actions
  ) {
    this.router = injector.get<Router>(Router);
    this.contentService = injector.get<ContentManagementService>(
      ContentManagementService
    );
  }

  aspectList$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ManageAspectsAction>(NodeActionTypes.ChangeAspects),
        map((action) => {
          if (action?.payload) {
            this.contentService.manageAspects(action.payload);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && !selection.isEmpty) {
                  this.contentService.manageAspects(
                    selection.nodes[0],
                    action.configuration?.focusedElementOnCloseSelector
                  );
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  expandInfoDrawer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ExpandInfoDrawerAction>(NodeActionTypes.ExpandInfoDrawer),
        map((action) => {
          if (action?.payload) {
            console.log(action.payload.entry.parentId);
            this.router.navigate([
              'libraries',
              action.payload.entry.parentId,
              'details',
              action.payload.entry.id,
            ]);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && !selection.isEmpty && selection.first) {
                  this.router.navigate([
                    'libraries',
                    selection.first.entry.parentId,
                    'details',
                    selection.first.entry.id,
                  ]);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );
}
